import { t as tinycolor } from '../../tinycolor-c9a47691.js';
import '../../typeof-92b42de1.js';

var getTextFill = function getTextFill(_ref) {
  var colorRGB1 = _ref.colorRGB1,
      colorOpacity = _ref.colorOpacity,
      colorTransparent = _ref.colorTransparent;
  return tinycolor(colorRGB1).setAlpha(colorTransparent ? 0 : colorOpacity !== undefined ? colorOpacity / 100 : colorRGB1.a || 100).toRgbString();
};

export { getTextFill as default };
